import React, { FC, useState }               from "react";
import { useDispatch, useSelector }          from "react-redux";
import { Button, Icon, Modal, Radio, Table } from "semantic-ui-react";
import GetStaffs                             from "../../../application/usecase/staff/GetStaffs";
import ReservationRepository                 from "../../../domain/reservation/ReservationRepository";
import Staff                                 from "../../../domain/staff/Staff";
import Staffs                                from "../../../domain/staff/Staffs";
import { ResKaState }                        from "../../../index";
import ReservationDataSource
                                             from "../../../infrastructure/datasource/reservation/ReservationDataSource";
import TopSection                            from "../common/layout/TopSection";

const ReservationStaffSelector: FC = () => {
  const [open, setOpen] = useState(false);
  const [selected, select] = useState(new Staff());
  const staff: Staff = useSelector((state: ResKaState) => state.reservation.staff);
  const staffs: Staffs = useSelector((state: ResKaState) => state.staffs);
  const getStaffs: GetStaffs = new GetStaffs(useDispatch());
  const repository: ReservationRepository = new ReservationDataSource(useDispatch());
  return (
    <>
      <Button
        icon
        labelPosition="left"
        onClick={ async () => {
          await getStaffs.execute();
          select(new Staff());
          setOpen(true);
        } }
      >
        <Icon name="male"/>
        {
          isNaN(staff.id.value)
            ?
            "対応するスタッフを選択する"
            :
            `${ staff.name.lastName.value } ${ staff.name.firstName.value }`
        }
      </Button>

      <Modal
        open={ open }
      >
        <Modal.Header>対応するスタッフの選択</Modal.Header>

        <Modal.Content>
          {
            staffs.isEmpty()
              ?
              <p>スタッフが登録されていません。</p>
              :
              <>
                <TopSection>
                  <Button
                    onClick={ () => {
                      repository.setReservationStaff(new Staff());
                      setOpen(false);
                    } }
                  >
                    選択済みのスタッフを解除する
                  </Button>
                </TopSection>
                <Table
                  striped
                  selectable
                >
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>選択</Table.HeaderCell>
                      <Table.HeaderCell>スタッフ名</Table.HeaderCell>
                      <Table.HeaderCell>性別</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {
                      staffs.toList().map(staff => (
                        <Table.Row onClick={ () => select(staff) }>
                          <Table.Cell width={ 2 }>
                            <Radio
                              name="ReservationStaffSelector"
                              checked={ selected.id.equals(staff.id) }
                              onChange={ () => select(staff) }
                            />
                          </Table.Cell>
                          <Table.Cell>{ `${ staff.name.lastName.value } ${ staff.name.firstName.value }` }</Table.Cell>
                          <Table.Cell>{ staff.genderLabel() }</Table.Cell>
                        </Table.Row>
                      ))
                    }
                  </Table.Body>
                </Table>
              </>
          }
        </Modal.Content>

        <Modal.Actions>
          <Button
            icon
            labelPosition="left"
            disabled={ isNaN(selected.id.value) }
            positive={ !isNaN(selected.id.value) }
            onClick={ () => {
              repository.setReservationStaff(selected);
              setOpen(false);
            } }
          >
            <Icon name="check"/>
            決定する
          </Button>

          <Button
            onClick={ () => setOpen(false) }
          >
            閉じる
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default ReservationStaffSelector;
